import { FC } from 'react';
import {
    Box,
    IconButton,
    Collapse,
    Card,
    CardContent,
    Chip,
    Typography,
    Divider,
    Stack
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { OfferResponseDTO } from '../../../../type/dto/RequestResponseDTO';
import { OfferPositionItem } from './OfferPositionItem';

interface OfferCardProps {
    offer: OfferResponseDTO;
    isExpanded: boolean;
    onToggle: () => void;
    onImageClick: (imageUrl: string) => void;
}

export const OfferCard: FC<OfferCardProps> = ({
    offer,
    isExpanded,
    onToggle,
    onImageClick
}) => {
    return (
        <Card variant="outlined" sx={{ bgcolor: 'background.default' }}>
            <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        cursor: 'pointer',
                    }}
                    onClick={onToggle}
                >
                    <Box>
                        <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                            Offer #{offer.id.substring(0, 8)}
                        </Typography>
                        <Chip
                            label={offer.status}
                            size="small"
                            color={
                                offer.status.includes('ACCEPTED')
                                    ? 'success'
                                    : offer.status.includes('CANCELLED')
                                    ? 'error'
                                    : offer.status === 'EXPIRED'
                                    ? 'warning'
                                    : 'default'
                            }
                            sx={{ mt: 0.5 }}
                        />
                    </Box>
                    <IconButton
                        size="small"
                        sx={{
                            transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                            transition: 'transform 0.3s',
                        }}
                    >
                        <ExpandMoreIcon />
                    </IconButton>
                </Box>

                <Collapse in={isExpanded}>
                    <Divider sx={{ my: 2 }} />
                    <Stack spacing={2}>
                        {offer.offerPositions.map((position, idx) => (
                            <OfferPositionItem
                                key={position.id}
                                position={position}
                                index={idx}
                                onImageClick={onImageClick}
                            />
                        ))}
                    </Stack>
                </Collapse>
            </CardContent>
        </Card>
    );
};

